import React, {useEffect, useState } from "react";
import useApi from "../../api";


import {
  NXNetSale,
  NXTotalOrder,
  NXTotalSales,
  NXTotalVariant,
} from "../../icons";
import { handleRetriveError } from "../../utils";

interface CardGroupProps {
  filterParams: any;
}


const CardGroup: React.FC<CardGroupProps> = ({ filterParams }) => {
  const [basicStats, setBasicStats] = useState<any>({});

  const api = useApi();

  const fetchState = () => {
    api.getBasicStats(filterParams).then((response) => {
      setBasicStats(response);
    },handleRetriveError)
  };

  useEffect(() => {
    if (filterParams.start_date && filterParams.end_date) {
      fetchState();
    }
  }, [filterParams]);

  return (
        <section className="grid grid-cols-1 md:grid-cols-2  lg:grid-cols-2 xl:grid-cols-4 gap-5 py-2">
          <div className="bg-white rounded-lg p-5 w-full h-[156px]">
            <h3 className="border-b border-[#EEEFF2] pb-2 text-base-300">
              Total Sales
            </h3>
            <div className="mt-5 flex gap-2 items-center justify-between">
              <div className="">
                <h6 className="font-nunito font-nunito-h1 text-2xl mb-2">
                  {basicStats?.sales?.amount}
                </h6>
                <p className="flex gap-1 text-[12px]">
                  <span
                    className={`${
                      basicStats?.sales?.last_percentage_change < 0 ? "text-red-500" : "text-primary-500"
                    }`}
                  >
                    {basicStats?.sales?.last_percentage_change}%
                  </span>
                  <span className="text-base-300">from {basicStats.percetage_change_preiod_title}</span>
                </p>
              </div>
              <div><NXTotalSales /></div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 w-full h-[156px]">
            <h3 className="border-b border-[#EEEFF2] pb-2 text-base-300">
              Total Order
            </h3>
            <div className="mt-5 flex gap-2 items-center justify-between">
              <div className="">
                <h6 className="font-nunito font-nunito-h1 text-2xl mb-2">
                  {basicStats?.orders?.amount}
                </h6>
                <p className="flex gap-1 text-[12px]">
                  <span
                    className={`${
                      basicStats?.orders?.last_percentage_change < 0 ? "text-red-500" : "text-primary-500"
                    }`}
                  >
                    {basicStats?.orders?.last_percentage_change}%
                  </span>
                  <span className="text-base-300">from {basicStats.percetage_change_preiod_title}</span>
                </p>
              </div>
              <div><NXTotalOrder /></div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 w-full h-[156px]">
            <h3 className="border-b border-[#EEEFF2] pb-2 text-base-300">
              Net Sales
            </h3>
            <div className="mt-5 flex gap-2 items-center justify-between">
              <div className="">
                <h6 className="font-nunito font-nunito-h1 text-2xl mb-2">
                  {basicStats?.net_sales?.amount}
                </h6>
                <p className="flex gap-1 text-[12px]">
                  <span
                    className={`${
                      basicStats?.net_sales?.last_percentage_change < 0 ? "text-red-500" : "text-primary-500"
                    }`}
                  >
                    {basicStats?.net_sales?.last_percentage_change}%
                  </span>
                  <span className="text-base-300">from {basicStats.percetage_change_preiod_title}</span>
                </p>
              </div>
              <div><NXNetSale /></div>
            </div>
          </div>

          <div className="bg-white rounded-lg p-5 w-full h-[156px]">
            <h3 className="border-b border-[#EEEFF2] pb-2 text-base-300">
              Total Variant Sold
            </h3>
            <div className="mt-5 flex gap-1 items-center justify-between">
              <div className="">
                <h6 className="font-nunito font-nunito-h1 text-xl mb-2">
                  {basicStats?.variants?.amount}
                </h6>
                {/* <p className="flex gap-1 text-[12px]">
                  <span
                    className={`${
                      1 < 0 ? "text-red-500" : "text-primary-500"
                    }`}
                  >
                    0%
                  </span>
                  <span className="text-base-300">from last week</span>
                </p> */}
              </div>
              <div><NXTotalVariant/></div>
            </div>
          </div>


      </section>
  );
}

export default CardGroup